export default __webpack_public_path__ + "static/media/7.6bbb6b3b.jpg";